module.exports = __webpack_public_path__ + "static/media/dummy_funding_graph.887d2336.png";